"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _styles = require("./styles");
var _pagination = require("../../utils/pagination");
var _Button = _interopRequireDefault(require("../Button"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ListPager = ({
  totalPageCount,
  currentPage,
  onFirstClick,
  onLastClick,
  onPageClick
}) => {
  const theme = (0, _react2.useTheme)();
  if (!(totalPageCount && totalPageCount > 0 && currentPage)) {
    return null;
  }
  const totalButtons = totalPageCount > 5 ? 5 : totalPageCount;
  const hasPreviousPages = (0, _pagination.getHasPreviousPages)(currentPage, totalPageCount);
  const hasMorePages = (0, _pagination.getHasMorePages)(currentPage, totalPageCount);
  const firstButtonIndex = (0, _pagination.getFirstButtonIndex)(currentPage, totalPageCount);
  const Dots = /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DotWrapper, {
    "aria-hidden": "true",
    children: "..."
  });
  let pages = [];
  for (let i = firstButtonIndex; i < firstButtonIndex + totalButtons; i++) {
    pages.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      onClick: () => onPageClick && onPageClick(i + 1),
      css: (0, _styles.PageStyle)(currentPage === i + 1, theme.primary),
      children: i + 1
    }, i));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    "aria-label": "Navigation",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      nostyle: true,
      onClick: onFirstClick,
      "aria-label": "G\xE5 til f\xF8rste side",
      children: "F\xF8rste"
    }), hasPreviousPages && Dots, pages, hasMorePages && Dots, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      "aria-label": "G\xE5 til siste side",
      nostyle: true,
      onClick: () => onLastClick && totalPageCount && onLastClick(totalPageCount),
      children: "Siste"
    })]
  });
};
var _default = exports.default = ListPager;